import React, { useRef } from 'react';
import uniqueId from 'lodash/uniqueId';

import useSidePaddingsOnHorizontalScroll from 'hooks/useSidePaddingsOnHorizontalScroll';
import Video from 'components/video';
import './styles.scss';

export type TImage = {
  src: string;
};

export type TVideo = {
  src: string;
  poster: string;
};

export type Media = TImage | TVideo;

interface IMediaCarousel {
  media: Media[];
}

const isVideo = (media: Media): media is TVideo => {
  return (media as TVideo).poster !== undefined;
}

const MediaCarousel: React.FC<IMediaCarousel> = ({ media }) => {
  const ref = useRef<HTMLDivElement>(null);

  useSidePaddingsOnHorizontalScroll(ref);

  return (
    <div className="flex overflow-x-scroll mb2 scrollable-gutters no-scroll" ref={ref}>
      {media.map((mediaItem) => {
        if (isVideo(mediaItem)) {
          return (
            <div className="media-item" key={uniqueId('media-item')}>
              <Video muted url={mediaItem.src} poster={mediaItem.poster} />
            </div>
          );
        }

        return (
          <div
            className="media-item"
            key={uniqueId('media-item')}
            style={{ backgroundImage: `url(${mediaItem.src})` }}
          />
        );
      })}
    </div>
  );
};

export default MediaCarousel;
